import cn from 'classnames'

import { HitProductCardSkeleton } from 'components/molecules/hit-product-card'

import css from './product-list-container.module.scss'

type ProductListContainerProps = {
  className?: string
  children: React.ReactNode
  isLoading: boolean
  numColumns?: number
}

export default function ProductListContainer({
  children,
  className,
  isLoading = false,
  numColumns = 5,
}: ProductListContainerProps) {
  return (
    <section className={cn([css.container, css[`container--${numColumns}cols`], className])}>
      {isLoading ? (
        <>
          <HitProductCardSkeleton key="skeleton-1" />
          <HitProductCardSkeleton key="skeleton-2" className={css.desktopOnlySkeleton} />
          <HitProductCardSkeleton key="skeleton-3" className={css.desktopOnlySkeleton} />
          <HitProductCardSkeleton key="skeleton-4" className={css.desktopOnlySkeleton} />
        </>
      ) : (
        children
      )}
    </section>
  )
}
